export const ScheduleViews = ['agenda', 'month', 'week', 'conflict'] as const;

export type ScheduleView = (typeof ScheduleViews)[number];
